import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";

import InstantSearch from "../../../ui/components/InstantSearch/InstantSearch";
import InstantSearchBox from "../../../ui/components/InstantSearch/InstantSearchBox";
import InstantSearchHits from "../../../ui/components/InstantSearch/InstantSearchHits";
import InstantSearchPagination from "../../../ui/components/InstantSearch/InstantSearchPagination";
import InstantSearchRefinements from "../../../ui/components/InstantSearch/InstantSearchRefinements";
import InstantSearchRefresh from "../../../ui/components/InstantSearch/InstantSearchRefresh";
import Menu from "../../../ui/components/Menu/Menu";
import PageView from "../../../ui/views/PageView/PageView";

import Table from "../../../tables/components/Table";

import AddUserButton from "../../components/AddUser/AddUserButton";
import useUsersRefinements from "../../hooks/useUsersRefinements";
import useUsersTableColumns from "../../hooks/useUsersTableColumns";

export default function UsersView({ organization }) {
	const { t } = useTranslation();

	const navigate = useNavigate();
	const [indexName, setIndexName] = useState("users");

	const columns = useUsersTableColumns({ organization, indexName });
	const refinements = useUsersRefinements({ organization, indexName });

	const configure = {
		filters: organization && `organizationIds:${organization.id}`,
		hitsPerPage: 10,
	};

	const options = [
		{
			text: t("users", "Users"),
			active: indexName === "users",
			onClick: () => setIndexName("users"),
		},
		{
			text: t("narrators", "Narrators"),
			active: indexName === "readers",
			onClick: () => setIndexName("readers"),
		},
	];

	return (
		<InstantSearch routing indexName={indexName} configure={configure}>
			<InstantSearchRefresh refreshInterval={5000} />
			<PageView
				header={t("users", "Users")}
				extra={
					organization && (
						<>
							<AddUserButton organization={organization} primary />

							{organization.type === organizationTypes.PRODUCER && (
								<AddUserButton organization={organization} reader />
							)}
						</>
					)
				}
				sidebar={
					<>
						{organization?.type === organizationTypes.PRODUCER && (
							<Menu secondary options={options} style={{ margin: "0 -5px 15px" }} />
						)}

						<InstantSearchBox />
						<InstantSearchRefinements refinements={refinements} />
					</>
				}
				maxWidth={1800}
			>
				<InstantSearchHits>
					{({ data }) => (
						<Table
							data={data}
							columns={columns}
							onClick={({ objectID }) => navigate(objectID)}
							// getDropdownMenuOptions={getDropdownMenuOptions}
						/>
					)}
				</InstantSearchHits>

				<InstantSearchPagination />
			</PageView>
		</InstantSearch>
	);
}
